import { AppInterface } from "./../types/types"
import { create } from "zustand"
import { devtools, persist } from "zustand/middleware"

interface State {
  submittedApp?: AppInterface
  search: string
  submitterDescription: string
  submitterPrice: string
  step: number
  submitApp: (submittedApp?: AppInterface) => void
  setSearch: (search: string) => void
  setDescription: (submitterDescription: string) => void
  setPrice: (submitterPrice: string) => void
  setStep: (step: number) => void
}

const useSubmitStore = create<State>()(
  devtools(
    persist(
      (set) => ({
        submittedApp: undefined,
        search: "",
        submitterDescription: "",
        submitterPrice: "",
        step: 0,
        submitApp: (submittedApp?: AppInterface) =>
          set((state) => ({ ...state, submittedApp })),
        setSearch: (search: string) => set((state) => ({ ...state, search })),
        setDescription: (submitterDescription: string) =>
          set((state) => ({ ...state, submitterDescription })),
        setPrice: (submitterPrice: string) =>
          set((state) => ({ ...state, submitterPrice })),
        setStep: (step: number) => set((state) => ({ ...state, step })),
      }),
      {
        name: "submit-store",
      },
    ),
    {
      name: "submit-store",
    },
  ),
)

export default useSubmitStore
